/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="95.58"
        height="98.4"
        viewBox="0 0 95.58 98.4"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#fff"
          d="M81.5 2.95a1.26 1.26 0 0 1 1.24 1.13v73.63a1.26 1.26 0 0 1-1.12 1.24H62.5a1.27 1.27 0 0 1-1.32-1.19 1.25 1.25 0 0 1 1.19-1.31H80.3v-71H69.84v9.83a1.26 1.26 0 0 1-1.12 1.17h-.13a1.24 1.24 0 0 1-1.24-1.13V4.2a1.24 1.24 0 0 1 1.15-1.24h13ZM14.11 23.5a1.24 1.24 0 0 1 1.24 1.12V76.5h17.8a1.26 1.26 0 0 1 1.25 1.12v.13a1.26 1.26 0 0 1-1.12 1.24H14.11a1.23 1.23 0 0 1-1.24-1.13v-53.1a1.24 1.24 0 0 1 1.24-1.26Z"
          className="icon-fill icon-base"/>
        <path
          fill="#fff"
          d="M47.08.22a1.22 1.22 0 0 1 1.3-.07l.12.07 46.54 31.87a1.25 1.25 0 0 1-1.3 2.13l-.11-.07L47.79 2.76 1.99 34.15a1.26 1.26 0 0 1-1.66-.22l-.08-.1a1.24 1.24 0 0 1 .22-1.66l.1-.08Z"
          className="icon-fill icon-base"/>
        <path
          fill="#ffb81c"
          d="M52.28 48.35h1c4.34 0 7.64.41 9.2 4.08a.34.34 0 0 0 .66-.14v-.07c-1.25-5.15-2.13-10.13-15.64-10.13-1.92 0-2.53 0-3.57 1.22s-1.44 1-1.44 1h-2.4a.49.49 0 0 1-.49-.49.9.9 0 0 0-.9-.9h-3.65a.89.89 0 0 0-.91.89v6.18a.91.91 0 0 0 .91.91h3.62a.91.91 0 0 0 .91-.91.49.49 0 0 1 .49-.49h2.92c2.47 0 2.67 3.13 2.67 3.13v11.75h4.21V51.5c0-1.72 1.07-3.12 2.4-3.12"
          className="icon-fill icon-accent"
          fillRule="evenodd"/>
        <path
          fill="#ffb81c"
          d="M49.84 63.5a4.17 4.17 0 0 1 2.2 2.73 3.23 3.23 0 0 1 .12 1.07v26.71a4.39 4.39 0 1 1-8.78 0V67.34a3.23 3.23 0 0 1 .12-1.07 4.13 4.13 0 0 1 2.2-2.77Z"
          className="icon-fill icon-accent"
          fillRule="evenodd"/>
      </svg>

    );
  }
}

Icon.displayName = 'HouseWithHammerIcon';

export default Icon;
